<script setup lang="ts">
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import HelpOverlay from "../components/HelpOverlay.vue";

const helpOpen = ref(false);
const route = useRoute();

// `?denied=1` is set by the OAuth callback in server/routes/auth.ts
// when a successfully-authenticated Google account isn't on the
// configured allowlist. The user has no session cookie at this
// point, so leaving the sign-in button enabled lets them retry with
// a different account without a manual refresh.
const denied = computed(() => route.query.denied === "1");

function signIn() {
  window.location.href = "/api/auth/login";
}
</script>

<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-bg-body px-4">
    <div
      data-testid="login-card"
      class="w-full max-w-sm rounded-xl border border-border bg-bg-main shadow-sm px-8 py-10 flex flex-col items-center gap-6"
    >
      <div class="flex flex-col items-center gap-2">
        <h1 class="text-2xl font-semibold text-text-primary">Rally Segmentation</h1>
        <p class="text-sm text-text-secondary text-center">
          Sign in to upload match videos and review rally segments.
        </p>
      </div>
      <div
        v-if="denied"
        data-testid="login-denied-banner"
        role="alert"
        class="w-full rounded-md border border-warning-border bg-warning-bg px-3 py-2 text-xs text-warning"
      >
        That Google account isn't on the allowlist. Try signing in with a different
        account, or contact the administrator if you think this is a mistake.
      </div>
      <button
        type="button"
        data-testid="sign-in-button"
        class="w-full rounded-md bg-primary px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-hover transition-colors"
        @click="signIn"
      >
        Sign in with Google
      </button>
      <button
        type="button"
        data-testid="login-help-link"
        class="text-xs text-text-tertiary hover:text-text-secondary transition-colors"
        @click="helpOpen = true"
      >
        What is this?
      </button>
    </div>
    <HelpOverlay :open="helpOpen" @close="helpOpen = false" />
  </div>
</template>
